import { BRAND, PAGE, SALESCODE_KEY } from "../common/Constants";

export default class AuthenticationFailureHandler {
  static execute = (authenticationRequest = null) => {
    const urlHasAccessCode = /[?&]code=/.test(window.location.href);

    if (urlHasAccessCode) {
      /*
        We don't want to redirect to ADFS as this has already been done.
        In this scenario, we have just returned from ADFS and App.js is 
        extracting the auth_code from URL and exchanging it with the EMP 
        Authorization App for a valid access_token.
      */
      return;
    }

    const page =
      sessionStorage.getItem(PAGE) ||
      (authenticationRequest && authenticationRequest["page"]);
    const salesCode =
      sessionStorage.getItem(SALESCODE_KEY) ||
      (authenticationRequest && authenticationRequest["salesCode"]);
    const brand =
      sessionStorage.getItem(BRAND) ||
      (authenticationRequest && authenticationRequest["brand"]);

    //Displaying ADFS login screen
    let stateParam = "";

    if (salesCode) {
      stateParam += ",salesCode=" + salesCode;
    }
    if (page) {
      stateParam += ",page=" + page;
    }
    if (brand) {
      stateParam += ",brand=" + brand;
    }

    const stateQuery = stateParam
      ? `&state=${encodeURIComponent(stateParam)}`
      : "";
    window.location.href = window.EMP.ENTRA_ENABLE
      ? window.EMP.ENTRA_URL + stateQuery
      : window.EMP.ADFS_URL + stateQuery;
  };

  /*
        Regarding the OAuth state parameter (from oauth.com): When the user is redirected back to your app,
        whatever value you include as the state will also be included in the redirect. This gives your app
        a chance to persist data between the user being directed to the authorization server and back again,
        such as using the state parameter as a session key. This may be used to indicate what action in the
        app to perform after authorization is complete, for example, indicating which of your app’s pages to
        redirect to after authorization.
     */
  static logout = () => {
    sessionStorage.clear();
    window.location.href = window.EMP.ENTRA_ENABLE
      ? window.EMP.ENTRA_LOGOUT_URI
      : window.EMP.LOGOUT_URI;
  };
}
